import styled from 'styled-components';
import { Button, Input } from '@fnacdarty/back-office-ui';

export const StyledContainer = styled.div`
	width: 100%;
	margin: auto;
	padding: 20px;
	text-align: center;
`;

export const StyledDescription = styled.p`
	color: ${({ theme }) => theme.colors.muted};
	font-size: 14px;
`;

export const StyledInput = styled(Input)`
	width: 40px;
	height: 40px;
	margin-bottom: 0;
	margin-right: 20px;
	border-color: ${({ theme }) => theme.colors.secondary};
	text-align: center;
	margin-bottom: 12px !important;
`;

export const StyledFormContainer = styled.form`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
`;

export const StyledCodeContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	width: 100%;
	&:last-child {
		margin-bottom: 12px !important;
	}
`;

export const StyledButton = styled(Button)`
	width: 25%;
`;
